import BaseRepositoryService from 'uplisting-frontend/services/repositories/-base';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export default class ClientPropertyRepositoryService extends BaseRepositoryService<
  ModelRegistry['client-property']
> {
  recordName = 'client-property';
  implementMethods = ['findAll', 'unloadAll', 'peekAll'];
}

declare module '@ember/service' {
  interface Registry {
    'repositories/client-property': ClientPropertyRepositoryService;
  }
}
